import React, { forwardRef } from 'react'
import { Checkbox } from '@/components/Inputs/CheckboxInput'
import { TermsAndConditionsLink } from '@/components/TermsAndConditionsLink'
import { useTranslation } from '@/localization/useTranslation'
import type { TranslationType } from '@/types/common'

import classes from './styles.module.scss'

interface TermsAndConditionsProps extends React.InputHTMLAttributes<HTMLInputElement> {
  termsAndConditions?: TranslationType
}

const TermsAndConditions = forwardRef<HTMLInputElement, TermsAndConditionsProps>(
  ({ termsAndConditions, ...props }, ref) => {
    return (
      <div className={classes.termsAndConditions}>
        <Checkbox
          label={<Label href={termsAndConditions} />}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)

const Label = ({ href }: { href?: TranslationType }) => {
  const { t } = useTranslation()

  return (
    <span className={classes.label}>
      {t('I have read and accepted the')}{' '}
      <TermsAndConditionsLink href={href} />
    </span>
  )
}

TermsAndConditions.displayName = 'TermsAndConditions'
export default TermsAndConditions
